module.exports = {
    blog_title:'タップ情報ゾーン',
    blog_desc: '関連する記事と製品の詳細をクリエイターに提供します。 Taption 関連の最新情報、ニュースなどもここで見つけることができます。 ',
    written_by: '作者',
}